export function AuthFooterLinks() {
  return (
    <div className='d-flex flex-center flex-wrap mt-8'>
      {/* begin::Links */}
      <div className='d-flex fw-semibold text-primary fs-base'>
        <a href='https://www.ofindo.de/datenschutz/?plattform=partner' className='px-5' target='_blank' rel="noreferrer">
          Datenschutz
        </a>
        <a href='https://www.ofindo.de/impressum/?plattform=partner' className='px-5' target='_blank' rel="noreferrer">
          Impressum
        </a>
      </div>
      {/* end::Links */}
    </div>
  )
}
